import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { map, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { EventCardsService } from 'src/app/services/event-cards.service';
import { EventCard } from 'src/interfaces/event-card.model';

@Component({
    selector: 'app-menu-event-slider',
    templateUrl: './menu-event-slider.component.html',
    styleUrls: ['./menu-event-slider.component.css'],
    standalone: false
})
export class MenuShowCardsComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private eventCardsService: EventCardsService, 
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    this.eventCards = [];

    this.width = 90;
    this.height = 115;
  }

  eventCards: EventCard[];
  private destroy$ = new Subject<void>();

  width: number;
  height: number;

  imageSrc: string | null = null; // Полноэкранное изображение

  ngOnInit(): void {
    this.eventCardsService.eventCards$.pipe(
      takeUntil(this.destroy$),
      map(eventCards => {
        const now = new Date();
        // Порядок — как в приложении («Переместить раньше / позже»): по index;
        // Firestore отдаёт документы в порядке id
        return eventCards
          .filter(eventCard => eventCard.deadline === null || eventCard.deadline >= now)
          .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
      }),
    ).subscribe(filtered => {
        // console.log('MenuShowCards | ngOnInit() | subscribe() | eventCards: ', filtered.length);
        if (filtered.length) {
          this.eventCards = filtered.filter(eventCard => eventCard.active);
        } else {
          this.eventCards = [];
        }
        this.cdr.detectChanges();
      });
  }

  ngAfterViewInit() {
    // Ширина экрана — после отрисовки: в конструкторе iOS отдавал ширину до
    // применения viewport (≥ 480), и карточки случайно были по ~120 px.
    // Теперь ~120 px явно — почти три в ряду на любом телефоне
    const vw = Math.min(document.documentElement.clientWidth || window.innerWidth || 480, 480);
    this.width = Math.min(120, (vw - 32) / 2.75);
    this.height = this.width * 1.27;
    this.cdr.detectChanges(); // Обновляем Angular-поток изменений
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClick(imageUrl: string): void {
    this.imageSrc = imageUrl;
    this.renderer.addClass(document.body, 'no-scroll'); // Отключаем скролл
  }

  onClose(event: Event): void {
    event.stopPropagation(); // Предотвращаем всплытие клика
    this.imageSrc = null;
    this.renderer.removeClass(document.body, 'no-scroll'); // Включаем скролл обратно
  }
}
